import { useEffect } from "react";
//Style CSS
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0
    });
  }, [pathname]);
  return null;
}